module.exports = __webpack_public_path__ + "img/ptzc-large-three.f5e558eb.png";